/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoConnectedMemberDto } from './WebApiCustomListsDtoConnectedMemberDto';
import {
    WebApiCustomListsDtoConnectedMemberDtoFromJSON,
    WebApiCustomListsDtoConnectedMemberDtoFromJSONTyped,
    WebApiCustomListsDtoConnectedMemberDtoToJSON,
} from './WebApiCustomListsDtoConnectedMemberDto';
import type { WebApiCustomListsDtoCustomListItemFieldValueDto } from './WebApiCustomListsDtoCustomListItemFieldValueDto';
import {
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON,
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON,
} from './WebApiCustomListsDtoCustomListItemFieldValueDto';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCustomListItemDto
 */
export interface WebApiCustomListsDtoCustomListItemDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    customListId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    companyId?: number | null;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoCustomListItemFieldValueDto>}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    fieldValues?: Array<WebApiCustomListsDtoCustomListItemFieldValueDto> | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    updatedBy?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    createdBy?: number | null;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoConnectedMemberDto>}
     * @memberof WebApiCustomListsDtoCustomListItemDto
     */
    connectedMembers?: Array<WebApiCustomListsDtoConnectedMemberDto> | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCustomListItemDto interface.
 */
export function instanceOfWebApiCustomListsDtoCustomListItemDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCustomListItemDtoFromJSON(json: any): WebApiCustomListsDtoCustomListItemDto {
    return WebApiCustomListsDtoCustomListItemDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCustomListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCustomListItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'fieldValues': !exists(json, 'fieldValues') ? undefined : (json['fieldValues'] === null ? null : (json['fieldValues'] as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'connectedMembers': !exists(json, 'connectedMembers') ? undefined : (json['connectedMembers'] === null ? null : (json['connectedMembers'] as Array<any>).map(WebApiCustomListsDtoConnectedMemberDtoFromJSON)),
    };
}

export function WebApiCustomListsDtoCustomListItemDtoToJSON(value?: WebApiCustomListsDtoCustomListItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'customListId': value.customListId,
        'companyId': value.companyId,
        'fieldValues': value.fieldValues === undefined ? undefined : (value.fieldValues === null ? null : (value.fieldValues as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON)),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
        'updatedBy': value.updatedBy,
        'createdBy': value.createdBy,
        'connectedMembers': value.connectedMembers === undefined ? undefined : (value.connectedMembers === null ? null : (value.connectedMembers as Array<any>).map(WebApiCustomListsDtoConnectedMemberDtoToJSON)),
    };
}

